export default "__VITE_ASSET__ZAMmQOeU__"